import React from "react";
import { Route, Switch } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import ProfileMenu from "./ProfileMenu/ProfileMenu";
import CustomBreadcrumb from "../../components/UI/Breadcrumb/CustomBreadcrumb";
import MobileProfileMenu from "./ProfileMenu/MobileProfileMenu";
import ProfileAddresses from "./ProfileAddresses/ProfileAddresses";
import BillingAddresses from "./ProfileAddresses/BillingAddresses";
import Orders from "../Orders/Orders";
import Profile from "./Profile/Profile";
import PasswordChange from "./PasswordChange/PasswordChange";
import NewSmartList from "../Smartlist/NewSmartList";
import * as actionCreators from "../../redux/store/actions/index"
import "./profile.styles.scss";
import Payment from "./Payment/Payment";

class ProfileContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jwt: null,
            userId: null
        }
    }

    renderBreadcrumb = () => {
        const { history } = this.props;
        const pathname = history.location.pathname;
        var level2 = null;
        switch (pathname) {
            case "/profile":
                level2 = { path: "/profile", label: "profileContainer.preview" }
                break;
            case "/profile/addresses":
                level2 = { path: "/profile/addresses", label: "profileContainer.shippingAddress" }
                break;
            case "/profile/billing":
                level2 = { path: "/profile/billing", label: "profileContainer.billingAddress" }
                break;
            case "/profile/password":
                level2 = { path: "/profile/password", label: "profileContainer.passwordChange" }
                break;
            case "/profile/orders":
                level2 = { path: "/profile/orders", label: "profileContainer.orders" }
                break;
            case "/profile/smartlists":
                level2 = { path: "/profile/smartlists", label: "profileContainer.slists" }
                break;
            case "/profile/payments":
                level2 = { path: "/profile/payments", label: "profileContainer.payments" }
                break;

            default: level2 = { path: "/profile", label: "profileContainer.preview" }
        }
        return level2;
    }

    render() {
        const { logout } = this.props;
        window.setData = this.setState.bind(this);
        return (
            <Translation>
                {t =>
                    <div className="profile-container">
                        <div className="profile-breadcrumb">
                            <CustomBreadcrumb
                                level1={{
                                    path: "/profile",
                                    label: "profile"
                                }}
                                level2={{
                                    ...this.renderBreadcrumb(),
                                    active: true
                                }}
                            />
                        </div>
                        <div className="page-grid mobile-padding">
                            <div className="grid-left">
                                <ProfileMenu />
                                <button className="logout-button" onClick={logout}>
                                    {t("profileContainer.logout")}
                                </button>
                            </div>
                            <div className="grid-right">
                                <div className="profile-content">
                                    <div className="d-flex justify-content-center">
                                        <MobileProfileMenu />
                                    </div>
                                    <Switch>
                                        <Route exact path='/profile' render={() => <Profile />} />
                                        <Route exact path='/profile/addresses' render={() => <ProfileAddresses />} />
                                        <Route exact path='/profile/billing' render={() => <BillingAddresses />} />
                                        <Route exact path='/profile/password' render={() => <PasswordChange />} />
                                        <Route exact path='/profile/orders' render={() => <Orders />} />
                                        <Route exact path='/profile/smartlists' render={() => <NewSmartList />} />
                                        <Route exact path='/profile/payments' render={() => <Payment jwt={this.state.jwt} userId={this.state.userId}/>} />
                                    </Switch>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Translation>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        slists: state.slists.slists,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(actionCreators.logout()),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileContainer));


